module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_08-6bbd61a9d661b198f2bf61c29fb735d5.png";